import { FilterService } from "./filter";
import itinaryService from "./itinary";
import { LocationService } from "./location";
import priceService from "./price";
import { QueryService2 } from "./query";
import { StoreService } from "./store";

class ServiceRegistry {
    constructor() {
        this._storeService = null;
        this._filterService = null;
        this._itinaryService = null;
        this._locationService = null;
        this._priceService = null;
        this._queryService = null;
    }

    get storeService() {
        if (this._storeService === null) {
            this._storeService = new StoreService();
        }
        return this._storeService;
    }

    get filterService() {
        if (this._filterService === null) {
            this._filterService = new FilterService();
            return this._filterService;
        }
        return this._filterService;
    }

    get itinaryService() {
        return itinaryService;
    }

    get locationService() {
        if (this._locationService === null) {
            this._locationService = new LocationService();
        }
        return this._locationService;
    }

    get priceService() {
        return priceService;
    }

    get queryService() {
        if (this._queryService === null) {
            this._queryService = new QueryService2();
        }
        return this._queryService;
    }
}

const SERVICE_REGISTRY = new ServiceRegistry();

export default SERVICE_REGISTRY;
